export default __webpack_public_path__ + "static/media/settings_mode.5a1616ef.svg";